import { ChevronRight } from 'lucide-react';
import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';

export interface BreadcrumbItem {
  label: ReactNode;
  /** Adres docelowy. Pominiety dla ostatniego, biezacego elementu. */
  to?: string;
}

export interface BreadcrumbsProps {
  items: readonly BreadcrumbItem[];
  className?: string;
}

/**
 * Sciezka nawigacji — „Summer Cup 2024 › 1/8 finału › Mecz #12”.
 *
 * Ostatni element jest oznaczony jako biezaca strona (`aria-current`)
 * i nie jest odnosnikiem.
 */
export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Ścieżka nawigacji" className={cn('min-w-0', className)}>
      <ol className="flex flex-wrap items-center gap-1.5 text-[0.8125rem]">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <Fragment key={index}>
              <li className="min-w-0">
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className="text-brand-text font-semibold transition-colors hover:underline"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-current={isLast ? 'page' : undefined}
                    className={isLast ? 'text-fg-muted' : 'text-brand-text font-semibold'}
                  >
                    {item.label}
                  </span>
                )}
              </li>

              {!isLast && (
                <li aria-hidden="true" className="text-fg-subtle flex items-center">
                  <ChevronRight className="size-3.5" />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
